import api from './api';

export const festivalService = {
  getFestivals: async (params = {}) => {
    const response = await api.get('/festivals', { params });
    return response.data;
  },

  getFestival: async (id) => {
    const response = await api.get(`/festivals/${id}`);
    return response.data;
  },

  createFestival: async (festivalData) => {
    const response = await api.post('/festivals', festivalData);
    return response.data;
  },

  updateFestival: async (id, festivalData) => {
    const response = await api.put(`/festivals/${id}`, festivalData);
    return response.data;
  },

  deleteFestival: async (id) => {
    const response = await api.delete(`/festivals/${id}`);
    return response.data;
  },

  getFestivalStats: async () => {
    const response = await api.get('/festivals/stats/overview');
    return response.data;
  }
};
